// source: buckets.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();
goog.exportSymbol('proto.api.buckets.pb.ArchiveConfig', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveInfoRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveInfoResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveInfoResponse.Archive', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveRenew', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveStatusRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveStatusResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveStatusResponse.Status', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveWatchRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.ArchiveWatchResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.CreateRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.CreateResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.DefaultArchiveConfigRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.DefaultArchiveConfigResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.LinksRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.LinksResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.ListIpfsPathRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.ListIpfsPathResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.ListPathRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.ListPathResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.ListRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.ListResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.Metadata', null, global);
goog.exportSymbol('proto.api.buckets.pb.PathAccessRole', null, global);
goog.exportSymbol('proto.api.buckets.pb.PathItem', null, global);
goog.exportSymbol('proto.api.buckets.pb.PullIpfsPathRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.PullIpfsPathResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.PullPathAccessRolesRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.PullPathAccessRolesResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.PullPathRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.PullPathResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.PushPathAccessRolesRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.PushPathAccessRolesResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.PushPathRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.PushPathRequest.Header', null, global);
goog.exportSymbol('proto.api.buckets.pb.PushPathRequest.PayloadCase', null, global);
goog.exportSymbol('proto.api.buckets.pb.PushPathResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.PushPathResponse.Event', null, global);
goog.exportSymbol('proto.api.buckets.pb.PushPathResponse.PayloadCase', null, global);
goog.exportSymbol('proto.api.buckets.pb.RemovePathRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.RemovePathResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.RemoveRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.RemoveResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.Root', null, global);
goog.exportSymbol('proto.api.buckets.pb.RootRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.RootResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.SetDefaultArchiveConfigRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.SetDefaultArchiveConfigResponse', null, global);
goog.exportSymbol('proto.api.buckets.pb.SetPathRequest', null, global);
goog.exportSymbol('proto.api.buckets.pb.SetPathResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.api.buckets.pb.Metadata = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.Metadata, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.Metadata.displayName = 'proto.api.buckets.pb.Metadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.Root = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.Root, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.Root.displayName = 'proto.api.buckets.pb.Root';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ListRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ListRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ListRequest.displayName = 'proto.api.buckets.pb.ListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ListResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.buckets.pb.ListResponse.repeatedFields_, null);
};

goog.inherits(proto.api.buckets.pb.ListResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ListResponse.displayName = 'proto.api.buckets.pb.ListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.CreateRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.CreateRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.CreateRequest.displayName = 'proto.api.buckets.pb.CreateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.CreateResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.CreateResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.CreateResponse.displayName = 'proto.api.buckets.pb.CreateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.RootRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.RootRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.RootRequest.displayName = 'proto.api.buckets.pb.RootRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.RootResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.RootResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.RootResponse.displayName = 'proto.api.buckets.pb.RootResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.LinksRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.LinksRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.LinksRequest.displayName = 'proto.api.buckets.pb.LinksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.LinksResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.LinksResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.LinksResponse.displayName = 'proto.api.buckets.pb.LinksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ListPathRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ListPathRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ListPathRequest.displayName = 'proto.api.buckets.pb.ListPathRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ListPathResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ListPathResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ListPathResponse.displayName = 'proto.api.buckets.pb.ListPathResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PathItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.buckets.pb.PathItem.repeatedFields_, null);
};

goog.inherits(proto.api.buckets.pb.PathItem, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PathItem.displayName = 'proto.api.buckets.pb.PathItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ListIpfsPathRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ListIpfsPathRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ListIpfsPathRequest.displayName = 'proto.api.buckets.pb.ListIpfsPathRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ListIpfsPathResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ListIpfsPathResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ListIpfsPathResponse.displayName = 'proto.api.buckets.pb.ListIpfsPathResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PushPathRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.api.buckets.pb.PushPathRequest.oneofGroups_);
};

goog.inherits(proto.api.buckets.pb.PushPathRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PushPathRequest.displayName = 'proto.api.buckets.pb.PushPathRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PushPathRequest.Header = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.PushPathRequest.Header, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PushPathRequest.Header.displayName = 'proto.api.buckets.pb.PushPathRequest.Header';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PushPathResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.api.buckets.pb.PushPathResponse.oneofGroups_);
};

goog.inherits(proto.api.buckets.pb.PushPathResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PushPathResponse.displayName = 'proto.api.buckets.pb.PushPathResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PushPathResponse.Event = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.PushPathResponse.Event, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PushPathResponse.Event.displayName = 'proto.api.buckets.pb.PushPathResponse.Event';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PullPathRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.PullPathRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PullPathRequest.displayName = 'proto.api.buckets.pb.PullPathRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PullPathResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.PullPathResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PullPathResponse.displayName = 'proto.api.buckets.pb.PullPathResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PullIpfsPathRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.PullIpfsPathRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PullIpfsPathRequest.displayName = 'proto.api.buckets.pb.PullIpfsPathRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PullIpfsPathResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.PullIpfsPathResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PullIpfsPathResponse.displayName = 'proto.api.buckets.pb.PullIpfsPathResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.SetPathRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.SetPathRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.SetPathRequest.displayName = 'proto.api.buckets.pb.SetPathRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.SetPathResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.SetPathResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.SetPathResponse.displayName = 'proto.api.buckets.pb.SetPathResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.RemoveRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.RemoveRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.RemoveRequest.displayName = 'proto.api.buckets.pb.RemoveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.RemoveResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.RemoveResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.RemoveResponse.displayName = 'proto.api.buckets.pb.RemoveResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.RemovePathRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.RemovePathRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.RemovePathRequest.displayName = 'proto.api.buckets.pb.RemovePathRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.RemovePathResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.RemovePathResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.RemovePathResponse.displayName = 'proto.api.buckets.pb.RemovePathResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PushPathAccessRolesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.PushPathAccessRolesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PushPathAccessRolesRequest.displayName = 'proto.api.buckets.pb.PushPathAccessRolesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PushPathAccessRolesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.PushPathAccessRolesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PushPathAccessRolesResponse.displayName = 'proto.api.buckets.pb.PushPathAccessRolesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PullPathAccessRolesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.PullPathAccessRolesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PullPathAccessRolesRequest.displayName = 'proto.api.buckets.pb.PullPathAccessRolesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.PullPathAccessRolesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.PullPathAccessRolesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.PullPathAccessRolesResponse.displayName = 'proto.api.buckets.pb.PullPathAccessRolesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveConfig = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.buckets.pb.ArchiveConfig.repeatedFields_, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveConfig, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveConfig.displayName = 'proto.api.buckets.pb.ArchiveConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveRenew = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveRenew, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveRenew.displayName = 'proto.api.buckets.pb.ArchiveRenew';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.DefaultArchiveConfigRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.DefaultArchiveConfigRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.DefaultArchiveConfigRequest.displayName = 'proto.api.buckets.pb.DefaultArchiveConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.DefaultArchiveConfigResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.DefaultArchiveConfigResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.DefaultArchiveConfigResponse.displayName = 'proto.api.buckets.pb.DefaultArchiveConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.SetDefaultArchiveConfigRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.SetDefaultArchiveConfigRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.SetDefaultArchiveConfigRequest.displayName = 'proto.api.buckets.pb.SetDefaultArchiveConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.SetDefaultArchiveConfigResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.SetDefaultArchiveConfigResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.SetDefaultArchiveConfigResponse.displayName = 'proto.api.buckets.pb.SetDefaultArchiveConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveRequest.displayName = 'proto.api.buckets.pb.ArchiveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveResponse.displayName = 'proto.api.buckets.pb.ArchiveResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveStatusRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveStatusRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveStatusRequest.displayName = 'proto.api.buckets.pb.ArchiveStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveStatusResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveStatusResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveStatusResponse.displayName = 'proto.api.buckets.pb.ArchiveStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveInfoRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveInfoRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveInfoRequest.displayName = 'proto.api.buckets.pb.ArchiveInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveInfoResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveInfoResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveInfoResponse.displayName = 'proto.api.buckets.pb.ArchiveInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.buckets.pb.ArchiveInfoResponse.Archive.repeatedFields_, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveInfoResponse.Archive, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveInfoResponse.Archive.displayName = 'proto.api.buckets.pb.ArchiveInfoResponse.Archive';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.displayName = 'proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveWatchRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveWatchRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveWatchRequest.displayName = 'proto.api.buckets.pb.ArchiveWatchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.buckets.pb.ArchiveWatchResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.buckets.pb.ArchiveWatchResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.buckets.pb.ArchiveWatchResponse.displayName = 'proto.api.buckets.pb.ArchiveWatchResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.Metadata.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.Metadata.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.Metadata} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.Metadata.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      rolesMap: (f = msg.getRolesMap()) ? f.toObject(includeInstance, undefined) : [],
      updatedAt: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.Metadata}
 */


proto.api.buckets.pb.Metadata.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.Metadata();
  return proto.api.buckets.pb.Metadata.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.Metadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.Metadata}
 */


proto.api.buckets.pb.Metadata.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = msg.getRolesMap();
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readEnum, null, "", 0);
        });
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setUpdatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.Metadata.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.Metadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.Metadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.Metadata.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getRolesMap(true);

  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeEnum);
  }

  f = message.getUpdatedAt();

  if (f !== 0) {
    writer.writeInt64(2, f);
  }
};
/**
 * map<string, PathAccessRole> roles = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.api.buckets.pb.PathAccessRole>}
 */


proto.api.buckets.pb.Metadata.prototype.getRolesMap = function (opt_noLazyCreate) {
  return (
    /** @type {!jspb.Map<string,!proto.api.buckets.pb.PathAccessRole>} */
    jspb.Message.getMapField(this, 1, opt_noLazyCreate, null)
  );
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.api.buckets.pb.Metadata} returns this
 */


proto.api.buckets.pb.Metadata.prototype.clearRolesMap = function () {
  this.getRolesMap().clear();
  return this;
};
/**
 * optional int64 updated_at = 2;
 * @return {number}
 */


proto.api.buckets.pb.Metadata.prototype.getUpdatedAt = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.Metadata} returns this
 */


proto.api.buckets.pb.Metadata.prototype.setUpdatedAt = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.Root.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.Root.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.Root} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.Root.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      path: jspb.Message.getFieldWithDefault(msg, 3, ""),
      createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
      updatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
      thread: jspb.Message.getFieldWithDefault(msg, 6, ""),
      owner: jspb.Message.getFieldWithDefault(msg, 7, ""),
      version: jspb.Message.getFieldWithDefault(msg, 8, 0),
      metadata: (f = msg.getMetadata()) && proto.api.buckets.pb.Metadata.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.Root}
 */


proto.api.buckets.pb.Root.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.Root();
  return proto.api.buckets.pb.Root.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.Root} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.Root}
 */


proto.api.buckets.pb.Root.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setCreatedAt(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setUpdatedAt(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setThread(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setOwner(value);
        break;

      case 8:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setVersion(value);
        break;

      case 9:
        var value = new proto.api.buckets.pb.Metadata();
        reader.readMessage(value, proto.api.buckets.pb.Metadata.deserializeBinaryFromReader);
        msg.setMetadata(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.Root.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.Root.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.Root} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.Root.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getCreatedAt();

  if (f !== 0) {
    writer.writeInt64(4, f);
  }

  f = message.getUpdatedAt();

  if (f !== 0) {
    writer.writeInt64(5, f);
  }

  f = message.getThread();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getOwner();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getVersion();

  if (f !== 0) {
    writer.writeInt32(8, f);
  }

  f = message.getMetadata();

  if (f != null) {
    writer.writeMessage(9, f, proto.api.buckets.pb.Metadata.serializeBinaryToWriter);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.Root.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.Root} returns this
 */


proto.api.buckets.pb.Root.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.api.buckets.pb.Root.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.Root} returns this
 */


proto.api.buckets.pb.Root.prototype.setName = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string path = 3;
 * @return {string}
 */


proto.api.buckets.pb.Root.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.Root} returns this
 */


proto.api.buckets.pb.Root.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 created_at = 4;
 * @return {number}
 */


proto.api.buckets.pb.Root.prototype.getCreatedAt = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.Root} returns this
 */


proto.api.buckets.pb.Root.prototype.setCreatedAt = function (value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 updated_at = 5;
 * @return {number}
 */


proto.api.buckets.pb.Root.prototype.getUpdatedAt = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.Root} returns this
 */


proto.api.buckets.pb.Root.prototype.setUpdatedAt = function (value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string thread = 6;
 * @return {string}
 */


proto.api.buckets.pb.Root.prototype.getThread = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.Root} returns this
 */


proto.api.buckets.pb.Root.prototype.setThread = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string owner = 7;
 * @return {string}
 */


proto.api.buckets.pb.Root.prototype.getOwner = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.Root} returns this
 */


proto.api.buckets.pb.Root.prototype.setOwner = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional int32 version = 8;
 * @return {number}
 */


proto.api.buckets.pb.Root.prototype.getVersion = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 8, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.Root} returns this
 */


proto.api.buckets.pb.Root.prototype.setVersion = function (value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional Metadata metadata = 9;
 * @return {?proto.api.buckets.pb.Metadata}
 */


proto.api.buckets.pb.Root.prototype.getMetadata = function () {
  return (
    /** @type{?proto.api.buckets.pb.Metadata} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.Metadata, 9)
  );
};
/**
 * @param {?proto.api.buckets.pb.Metadata|undefined} value
 * @return {!proto.api.buckets.pb.Root} returns this
*/


proto.api.buckets.pb.Root.prototype.setMetadata = function (value) {
  return jspb.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.Root} returns this
 */


proto.api.buckets.pb.Root.prototype.clearMetadata = function () {
  return this.setMetadata(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.Root.prototype.hasMetadata = function () {
  return jspb.Message.getField(this, 9) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ListRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ListRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ListRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ListRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ListRequest}
 */


proto.api.buckets.pb.ListRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ListRequest();
  return proto.api.buckets.pb.ListRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ListRequest}
 */


proto.api.buckets.pb.ListRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ListRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ListRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.api.buckets.pb.ListResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ListResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ListResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ListResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ListResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      rootsList: jspb.Message.toObjectList(msg.getRootsList(), proto.api.buckets.pb.Root.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ListResponse}
 */


proto.api.buckets.pb.ListResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ListResponse();
  return proto.api.buckets.pb.ListResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ListResponse}
 */


proto.api.buckets.pb.ListResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.buckets.pb.Root();
        reader.readMessage(value, proto.api.buckets.pb.Root.deserializeBinaryFromReader);
        msg.addRoots(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ListResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ListResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getRootsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.api.buckets.pb.Root.serializeBinaryToWriter);
  }
};
/**
 * repeated Root roots = 1;
 * @return {!Array<!proto.api.buckets.pb.Root>}
 */


proto.api.buckets.pb.ListResponse.prototype.getRootsList = function () {
  return (
    /** @type{!Array<!proto.api.buckets.pb.Root>} */
    jspb.Message.getRepeatedWrapperField(this, proto.api.buckets.pb.Root, 1)
  );
};
/**
 * @param {!Array<!proto.api.buckets.pb.Root>} value
 * @return {!proto.api.buckets.pb.ListResponse} returns this
*/


proto.api.buckets.pb.ListResponse.prototype.setRootsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.api.buckets.pb.Root=} opt_value
 * @param {number=} opt_index
 * @return {!proto.api.buckets.pb.Root}
 */


proto.api.buckets.pb.ListResponse.prototype.addRoots = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.api.buckets.pb.Root, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.buckets.pb.ListResponse} returns this
 */


proto.api.buckets.pb.ListResponse.prototype.clearRootsList = function () {
  return this.setRootsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.CreateRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.CreateRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.CreateRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.CreateRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      name: jspb.Message.getFieldWithDefault(msg, 1, ""),
      bootstrapCid: jspb.Message.getFieldWithDefault(msg, 2, ""),
      pb_private: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.CreateRequest}
 */


proto.api.buckets.pb.CreateRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.CreateRequest();
  return proto.api.buckets.pb.CreateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.CreateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.CreateRequest}
 */


proto.api.buckets.pb.CreateRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBootstrapCid(value);
        break;

      case 3:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setPrivate(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.CreateRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.CreateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.CreateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.CreateRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getBootstrapCid();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getPrivate();

  if (f) {
    writer.writeBool(3, f);
  }
};
/**
 * optional string name = 1;
 * @return {string}
 */


proto.api.buckets.pb.CreateRequest.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.CreateRequest} returns this
 */


proto.api.buckets.pb.CreateRequest.prototype.setName = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string bootstrap_cid = 2;
 * @return {string}
 */


proto.api.buckets.pb.CreateRequest.prototype.getBootstrapCid = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.CreateRequest} returns this
 */


proto.api.buckets.pb.CreateRequest.prototype.setBootstrapCid = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional bool private = 3;
 * @return {boolean}
 */


proto.api.buckets.pb.CreateRequest.prototype.getPrivate = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 3, false)
  );
};
/**
 * @param {boolean} value
 * @return {!proto.api.buckets.pb.CreateRequest} returns this
 */


proto.api.buckets.pb.CreateRequest.prototype.setPrivate = function (value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.CreateResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.CreateResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.CreateResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.CreateResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      root: (f = msg.getRoot()) && proto.api.buckets.pb.Root.toObject(includeInstance, f),
      links: (f = msg.getLinks()) && proto.api.buckets.pb.LinksResponse.toObject(includeInstance, f),
      seed: msg.getSeed_asB64(),
      seedCid: jspb.Message.getFieldWithDefault(msg, 4, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.CreateResponse}
 */


proto.api.buckets.pb.CreateResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.CreateResponse();
  return proto.api.buckets.pb.CreateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.CreateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.CreateResponse}
 */


proto.api.buckets.pb.CreateResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.buckets.pb.Root();
        reader.readMessage(value, proto.api.buckets.pb.Root.deserializeBinaryFromReader);
        msg.setRoot(value);
        break;

      case 2:
        var value = new proto.api.buckets.pb.LinksResponse();
        reader.readMessage(value, proto.api.buckets.pb.LinksResponse.deserializeBinaryFromReader);
        msg.setLinks(value);
        break;

      case 3:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setSeed(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSeedCid(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.CreateResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.CreateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.CreateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.CreateResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getRoot();

  if (f != null) {
    writer.writeMessage(1, f, proto.api.buckets.pb.Root.serializeBinaryToWriter);
  }

  f = message.getLinks();

  if (f != null) {
    writer.writeMessage(2, f, proto.api.buckets.pb.LinksResponse.serializeBinaryToWriter);
  }

  f = message.getSeed_asU8();

  if (f.length > 0) {
    writer.writeBytes(3, f);
  }

  f = message.getSeedCid();

  if (f.length > 0) {
    writer.writeString(4, f);
  }
};
/**
 * optional Root root = 1;
 * @return {?proto.api.buckets.pb.Root}
 */


proto.api.buckets.pb.CreateResponse.prototype.getRoot = function () {
  return (
    /** @type{?proto.api.buckets.pb.Root} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.Root, 1)
  );
};
/**
 * @param {?proto.api.buckets.pb.Root|undefined} value
 * @return {!proto.api.buckets.pb.CreateResponse} returns this
*/


proto.api.buckets.pb.CreateResponse.prototype.setRoot = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.CreateResponse} returns this
 */


proto.api.buckets.pb.CreateResponse.prototype.clearRoot = function () {
  return this.setRoot(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.CreateResponse.prototype.hasRoot = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional LinksResponse links = 2;
 * @return {?proto.api.buckets.pb.LinksResponse}
 */


proto.api.buckets.pb.CreateResponse.prototype.getLinks = function () {
  return (
    /** @type{?proto.api.buckets.pb.LinksResponse} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.LinksResponse, 2)
  );
};
/**
 * @param {?proto.api.buckets.pb.LinksResponse|undefined} value
 * @return {!proto.api.buckets.pb.CreateResponse} returns this
*/


proto.api.buckets.pb.CreateResponse.prototype.setLinks = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.CreateResponse} returns this
 */


proto.api.buckets.pb.CreateResponse.prototype.clearLinks = function () {
  return this.setLinks(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.CreateResponse.prototype.hasLinks = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional bytes seed = 3;
 * @return {!(string|Uint8Array)}
 */


proto.api.buckets.pb.CreateResponse.prototype.getSeed = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * optional bytes seed = 3;
 * This is a type-conversion wrapper around `getSeed()`
 * @return {string}
 */


proto.api.buckets.pb.CreateResponse.prototype.getSeed_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getSeed())
  );
};
/**
 * optional bytes seed = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSeed()`
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.CreateResponse.prototype.getSeed_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getSeed())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.buckets.pb.CreateResponse} returns this
 */


proto.api.buckets.pb.CreateResponse.prototype.setSeed = function (value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional string seed_cid = 4;
 * @return {string}
 */


proto.api.buckets.pb.CreateResponse.prototype.getSeedCid = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.CreateResponse} returns this
 */


proto.api.buckets.pb.CreateResponse.prototype.setSeedCid = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.RootRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.RootRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.RootRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.RootRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.RootRequest}
 */


proto.api.buckets.pb.RootRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.RootRequest();
  return proto.api.buckets.pb.RootRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.RootRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.RootRequest}
 */


proto.api.buckets.pb.RootRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.RootRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.RootRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.RootRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.RootRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.RootRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.RootRequest} returns this
 */


proto.api.buckets.pb.RootRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.RootResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.RootResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.RootResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.RootResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      root: (f = msg.getRoot()) && proto.api.buckets.pb.Root.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.RootResponse}
 */


proto.api.buckets.pb.RootResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.RootResponse();
  return proto.api.buckets.pb.RootResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.RootResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.RootResponse}
 */


proto.api.buckets.pb.RootResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.buckets.pb.Root();
        reader.readMessage(value, proto.api.buckets.pb.Root.deserializeBinaryFromReader);
        msg.setRoot(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.RootResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.RootResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.RootResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.RootResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getRoot();

  if (f != null) {
    writer.writeMessage(1, f, proto.api.buckets.pb.Root.serializeBinaryToWriter);
  }
};
/**
 * optional Root root = 1;
 * @return {?proto.api.buckets.pb.Root}
 */


proto.api.buckets.pb.RootResponse.prototype.getRoot = function () {
  return (
    /** @type{?proto.api.buckets.pb.Root} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.Root, 1)
  );
};
/**
 * @param {?proto.api.buckets.pb.Root|undefined} value
 * @return {!proto.api.buckets.pb.RootResponse} returns this
*/


proto.api.buckets.pb.RootResponse.prototype.setRoot = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.RootResponse} returns this
 */


proto.api.buckets.pb.RootResponse.prototype.clearRoot = function () {
  return this.setRoot(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.RootResponse.prototype.hasRoot = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.LinksRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.LinksRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.LinksRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.LinksRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      path: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.LinksRequest}
 */


proto.api.buckets.pb.LinksRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.LinksRequest();
  return proto.api.buckets.pb.LinksRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.LinksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.LinksRequest}
 */


proto.api.buckets.pb.LinksRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.LinksRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.LinksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.LinksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.LinksRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.LinksRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.LinksRequest} returns this
 */


proto.api.buckets.pb.LinksRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */


proto.api.buckets.pb.LinksRequest.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.LinksRequest} returns this
 */


proto.api.buckets.pb.LinksRequest.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.LinksResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.LinksResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.LinksResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.LinksResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      url: jspb.Message.getFieldWithDefault(msg, 1, ""),
      www: jspb.Message.getFieldWithDefault(msg, 2, ""),
      ipns: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.LinksResponse}
 */


proto.api.buckets.pb.LinksResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.LinksResponse();
  return proto.api.buckets.pb.LinksResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.LinksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.LinksResponse}
 */


proto.api.buckets.pb.LinksResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setUrl(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setWww(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setIpns(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.LinksResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.LinksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.LinksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.LinksResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUrl();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getWww();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getIpns();

  if (f.length > 0) {
    writer.writeString(3, f);
  }
};
/**
 * optional string url = 1;
 * @return {string}
 */


proto.api.buckets.pb.LinksResponse.prototype.getUrl = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.LinksResponse} returns this
 */


proto.api.buckets.pb.LinksResponse.prototype.setUrl = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string www = 2;
 * @return {string}
 */


proto.api.buckets.pb.LinksResponse.prototype.getWww = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.LinksResponse} returns this
 */


proto.api.buckets.pb.LinksResponse.prototype.setWww = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string ipns = 3;
 * @return {string}
 */


proto.api.buckets.pb.LinksResponse.prototype.getIpns = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.LinksResponse} returns this
 */


proto.api.buckets.pb.LinksResponse.prototype.setIpns = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ListPathRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ListPathRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ListPathRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ListPathRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      path: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ListPathRequest}
 */


proto.api.buckets.pb.ListPathRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ListPathRequest();
  return proto.api.buckets.pb.ListPathRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ListPathRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ListPathRequest}
 */


proto.api.buckets.pb.ListPathRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ListPathRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ListPathRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ListPathRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ListPathRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.ListPathRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ListPathRequest} returns this
 */


proto.api.buckets.pb.ListPathRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */


proto.api.buckets.pb.ListPathRequest.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ListPathRequest} returns this
 */


proto.api.buckets.pb.ListPathRequest.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ListPathResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ListPathResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ListPathResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ListPathResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      item: (f = msg.getItem()) && proto.api.buckets.pb.PathItem.toObject(includeInstance, f),
      root: (f = msg.getRoot()) && proto.api.buckets.pb.Root.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ListPathResponse}
 */


proto.api.buckets.pb.ListPathResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ListPathResponse();
  return proto.api.buckets.pb.ListPathResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ListPathResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ListPathResponse}
 */


proto.api.buckets.pb.ListPathResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.buckets.pb.PathItem();
        reader.readMessage(value, proto.api.buckets.pb.PathItem.deserializeBinaryFromReader);
        msg.setItem(value);
        break;

      case 2:
        var value = new proto.api.buckets.pb.Root();
        reader.readMessage(value, proto.api.buckets.pb.Root.deserializeBinaryFromReader);
        msg.setRoot(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ListPathResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ListPathResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ListPathResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ListPathResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getItem();

  if (f != null) {
    writer.writeMessage(1, f, proto.api.buckets.pb.PathItem.serializeBinaryToWriter);
  }

  f = message.getRoot();

  if (f != null) {
    writer.writeMessage(2, f, proto.api.buckets.pb.Root.serializeBinaryToWriter);
  }
};
/**
 * optional PathItem item = 1;
 * @return {?proto.api.buckets.pb.PathItem}
 */


proto.api.buckets.pb.ListPathResponse.prototype.getItem = function () {
  return (
    /** @type{?proto.api.buckets.pb.PathItem} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.PathItem, 1)
  );
};
/**
 * @param {?proto.api.buckets.pb.PathItem|undefined} value
 * @return {!proto.api.buckets.pb.ListPathResponse} returns this
*/


proto.api.buckets.pb.ListPathResponse.prototype.setItem = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.ListPathResponse} returns this
 */


proto.api.buckets.pb.ListPathResponse.prototype.clearItem = function () {
  return this.setItem(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.ListPathResponse.prototype.hasItem = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional Root root = 2;
 * @return {?proto.api.buckets.pb.Root}
 */


proto.api.buckets.pb.ListPathResponse.prototype.getRoot = function () {
  return (
    /** @type{?proto.api.buckets.pb.Root} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.Root, 2)
  );
};
/**
 * @param {?proto.api.buckets.pb.Root|undefined} value
 * @return {!proto.api.buckets.pb.ListPathResponse} returns this
*/


proto.api.buckets.pb.ListPathResponse.prototype.setRoot = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.ListPathResponse} returns this
 */


proto.api.buckets.pb.ListPathResponse.prototype.clearRoot = function () {
  return this.setRoot(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.ListPathResponse.prototype.hasRoot = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.api.buckets.pb.PathItem.repeatedFields_ = [6];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PathItem.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PathItem.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PathItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PathItem.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      cid: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      path: jspb.Message.getFieldWithDefault(msg, 3, ""),
      size: jspb.Message.getFieldWithDefault(msg, 4, 0),
      isDir: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
      itemsList: jspb.Message.toObjectList(msg.getItemsList(), proto.api.buckets.pb.PathItem.toObject, includeInstance),
      itemsCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
      metadata: (f = msg.getMetadata()) && proto.api.buckets.pb.Metadata.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PathItem}
 */


proto.api.buckets.pb.PathItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PathItem();
  return proto.api.buckets.pb.PathItem.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PathItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PathItem}
 */


proto.api.buckets.pb.PathItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCid(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setSize(value);
        break;

      case 5:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsDir(value);
        break;

      case 6:
        var value = new proto.api.buckets.pb.PathItem();
        reader.readMessage(value, proto.api.buckets.pb.PathItem.deserializeBinaryFromReader);
        msg.addItems(value);
        break;

      case 7:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setItemsCount(value);
        break;

      case 9:
        var value = new proto.api.buckets.pb.Metadata();
        reader.readMessage(value, proto.api.buckets.pb.Metadata.deserializeBinaryFromReader);
        msg.setMetadata(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PathItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PathItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PathItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PathItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCid();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getSize();

  if (f !== 0) {
    writer.writeInt64(4, f);
  }

  f = message.getIsDir();

  if (f) {
    writer.writeBool(5, f);
  }

  f = message.getItemsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(6, f, proto.api.buckets.pb.PathItem.serializeBinaryToWriter);
  }

  f = message.getItemsCount();

  if (f !== 0) {
    writer.writeInt32(7, f);
  }

  f = message.getMetadata();

  if (f != null) {
    writer.writeMessage(9, f, proto.api.buckets.pb.Metadata.serializeBinaryToWriter);
  }
};
/**
 * optional string cid = 1;
 * @return {string}
 */


proto.api.buckets.pb.PathItem.prototype.getCid = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PathItem} returns this
 */


proto.api.buckets.pb.PathItem.prototype.setCid = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.api.buckets.pb.PathItem.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PathItem} returns this
 */


proto.api.buckets.pb.PathItem.prototype.setName = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string path = 3;
 * @return {string}
 */


proto.api.buckets.pb.PathItem.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PathItem} returns this
 */


proto.api.buckets.pb.PathItem.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 size = 4;
 * @return {number}
 */


proto.api.buckets.pb.PathItem.prototype.getSize = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.PathItem} returns this
 */


proto.api.buckets.pb.PathItem.prototype.setSize = function (value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional bool is_dir = 5;
 * @return {boolean}
 */


proto.api.buckets.pb.PathItem.prototype.getIsDir = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 5, false)
  );
};
/**
 * @param {boolean} value
 * @return {!proto.api.buckets.pb.PathItem} returns this
 */


proto.api.buckets.pb.PathItem.prototype.setIsDir = function (value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};
/**
 * repeated PathItem items = 6;
 * @return {!Array<!proto.api.buckets.pb.PathItem>}
 */


proto.api.buckets.pb.PathItem.prototype.getItemsList = function () {
  return (
    /** @type{!Array<!proto.api.buckets.pb.PathItem>} */
    jspb.Message.getRepeatedWrapperField(this, proto.api.buckets.pb.PathItem, 6)
  );
};
/**
 * @param {!Array<!proto.api.buckets.pb.PathItem>} value
 * @return {!proto.api.buckets.pb.PathItem} returns this
*/


proto.api.buckets.pb.PathItem.prototype.setItemsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.api.buckets.pb.PathItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.api.buckets.pb.PathItem}
 */


proto.api.buckets.pb.PathItem.prototype.addItems = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.api.buckets.pb.PathItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.buckets.pb.PathItem} returns this
 */


proto.api.buckets.pb.PathItem.prototype.clearItemsList = function () {
  return this.setItemsList([]);
};
/**
 * optional int32 items_count = 7;
 * @return {number}
 */


proto.api.buckets.pb.PathItem.prototype.getItemsCount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.PathItem} returns this
 */


proto.api.buckets.pb.PathItem.prototype.setItemsCount = function (value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional Metadata metadata = 9;
 * @return {?proto.api.buckets.pb.Metadata}
 */


proto.api.buckets.pb.PathItem.prototype.getMetadata = function () {
  return (
    /** @type{?proto.api.buckets.pb.Metadata} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.Metadata, 9)
  );
};
/**
 * @param {?proto.api.buckets.pb.Metadata|undefined} value
 * @return {!proto.api.buckets.pb.PathItem} returns this
*/


proto.api.buckets.pb.PathItem.prototype.setMetadata = function (value) {
  return jspb.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.PathItem} returns this
 */


proto.api.buckets.pb.PathItem.prototype.clearMetadata = function () {
  return this.setMetadata(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.PathItem.prototype.hasMetadata = function () {
  return jspb.Message.getField(this, 9) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ListIpfsPathRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ListIpfsPathRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ListIpfsPathRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ListIpfsPathRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      path: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ListIpfsPathRequest}
 */


proto.api.buckets.pb.ListIpfsPathRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ListIpfsPathRequest();
  return proto.api.buckets.pb.ListIpfsPathRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ListIpfsPathRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ListIpfsPathRequest}
 */


proto.api.buckets.pb.ListIpfsPathRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ListIpfsPathRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ListIpfsPathRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ListIpfsPathRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ListIpfsPathRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string path = 1;
 * @return {string}
 */


proto.api.buckets.pb.ListIpfsPathRequest.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ListIpfsPathRequest} returns this
 */


proto.api.buckets.pb.ListIpfsPathRequest.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ListIpfsPathResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ListIpfsPathResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ListIpfsPathResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ListIpfsPathResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      item: (f = msg.getItem()) && proto.api.buckets.pb.PathItem.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ListIpfsPathResponse}
 */


proto.api.buckets.pb.ListIpfsPathResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ListIpfsPathResponse();
  return proto.api.buckets.pb.ListIpfsPathResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ListIpfsPathResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ListIpfsPathResponse}
 */


proto.api.buckets.pb.ListIpfsPathResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.buckets.pb.PathItem();
        reader.readMessage(value, proto.api.buckets.pb.PathItem.deserializeBinaryFromReader);
        msg.setItem(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ListIpfsPathResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ListIpfsPathResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ListIpfsPathResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ListIpfsPathResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getItem();

  if (f != null) {
    writer.writeMessage(1, f, proto.api.buckets.pb.PathItem.serializeBinaryToWriter);
  }
};
/**
 * optional PathItem item = 1;
 * @return {?proto.api.buckets.pb.PathItem}
 */


proto.api.buckets.pb.ListIpfsPathResponse.prototype.getItem = function () {
  return (
    /** @type{?proto.api.buckets.pb.PathItem} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.PathItem, 1)
  );
};
/**
 * @param {?proto.api.buckets.pb.PathItem|undefined} value
 * @return {!proto.api.buckets.pb.ListIpfsPathResponse} returns this
*/


proto.api.buckets.pb.ListIpfsPathResponse.prototype.setItem = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.ListIpfsPathResponse} returns this
 */


proto.api.buckets.pb.ListIpfsPathResponse.prototype.clearItem = function () {
  return this.setItem(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.ListIpfsPathResponse.prototype.hasItem = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */


proto.api.buckets.pb.PushPathRequest.oneofGroups_ = [[1, 2]];
/**
 * @enum {number}
 */

proto.api.buckets.pb.PushPathRequest.PayloadCase = {
  PAYLOAD_NOT_SET: 0,
  HEADER: 1,
  CHUNK: 2
};
/**
 * @return {proto.api.buckets.pb.PushPathRequest.PayloadCase}
 */

proto.api.buckets.pb.PushPathRequest.prototype.getPayloadCase = function () {
  return (
    /** @type {proto.api.buckets.pb.PushPathRequest.PayloadCase} */
    jspb.Message.computeOneofCase(this, proto.api.buckets.pb.PushPathRequest.oneofGroups_[0])
  );
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PushPathRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PushPathRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PushPathRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PushPathRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      header: (f = msg.getHeader()) && proto.api.buckets.pb.PushPathRequest.Header.toObject(includeInstance, f),
      chunk: msg.getChunk_asB64()
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PushPathRequest}
 */


proto.api.buckets.pb.PushPathRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PushPathRequest();
  return proto.api.buckets.pb.PushPathRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PushPathRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PushPathRequest}
 */


proto.api.buckets.pb.PushPathRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.buckets.pb.PushPathRequest.Header();
        reader.readMessage(value, proto.api.buckets.pb.PushPathRequest.Header.deserializeBinaryFromReader);
        msg.setHeader(value);
        break;

      case 2:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setChunk(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PushPathRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PushPathRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PushPathRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PushPathRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHeader();

  if (f != null) {
    writer.writeMessage(1, f, proto.api.buckets.pb.PushPathRequest.Header.serializeBinaryToWriter);
  }

  f =
  /** @type {!(string|Uint8Array)} */
  jspb.Message.getField(message, 2);

  if (f != null) {
    writer.writeBytes(2, f);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PushPathRequest.Header.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PushPathRequest.Header.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PushPathRequest.Header} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PushPathRequest.Header.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      path: jspb.Message.getFieldWithDefault(msg, 2, ""),
      root: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PushPathRequest.Header}
 */


proto.api.buckets.pb.PushPathRequest.Header.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PushPathRequest.Header();
  return proto.api.buckets.pb.PushPathRequest.Header.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PushPathRequest.Header} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PushPathRequest.Header}
 */


proto.api.buckets.pb.PushPathRequest.Header.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setRoot(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PushPathRequest.Header.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PushPathRequest.Header.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PushPathRequest.Header} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PushPathRequest.Header.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getRoot();

  if (f.length > 0) {
    writer.writeString(3, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.PushPathRequest.Header.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PushPathRequest.Header} returns this
 */


proto.api.buckets.pb.PushPathRequest.Header.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */


proto.api.buckets.pb.PushPathRequest.Header.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PushPathRequest.Header} returns this
 */


proto.api.buckets.pb.PushPathRequest.Header.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string root = 3;
 * @return {string}
 */


proto.api.buckets.pb.PushPathRequest.Header.prototype.getRoot = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PushPathRequest.Header} returns this
 */


proto.api.buckets.pb.PushPathRequest.Header.prototype.setRoot = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional Header header = 1;
 * @return {?proto.api.buckets.pb.PushPathRequest.Header}
 */


proto.api.buckets.pb.PushPathRequest.prototype.getHeader = function () {
  return (
    /** @type{?proto.api.buckets.pb.PushPathRequest.Header} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.PushPathRequest.Header, 1)
  );
};
/**
 * @param {?proto.api.buckets.pb.PushPathRequest.Header|undefined} value
 * @return {!proto.api.buckets.pb.PushPathRequest} returns this
*/


proto.api.buckets.pb.PushPathRequest.prototype.setHeader = function (value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.api.buckets.pb.PushPathRequest.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.PushPathRequest} returns this
 */


proto.api.buckets.pb.PushPathRequest.prototype.clearHeader = function () {
  return this.setHeader(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.PushPathRequest.prototype.hasHeader = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional bytes chunk = 2;
 * @return {!(string|Uint8Array)}
 */


proto.api.buckets.pb.PushPathRequest.prototype.getChunk = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * optional bytes chunk = 2;
 * This is a type-conversion wrapper around `getChunk()`
 * @return {string}
 */


proto.api.buckets.pb.PushPathRequest.prototype.getChunk_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getChunk())
  );
};
/**
 * optional bytes chunk = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChunk()`
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PushPathRequest.prototype.getChunk_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getChunk())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.buckets.pb.PushPathRequest} returns this
 */


proto.api.buckets.pb.PushPathRequest.prototype.setChunk = function (value) {
  return jspb.Message.setOneofField(this, 2, proto.api.buckets.pb.PushPathRequest.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.api.buckets.pb.PushPathRequest} returns this
 */


proto.api.buckets.pb.PushPathRequest.prototype.clearChunk = function () {
  return jspb.Message.setOneofField(this, 2, proto.api.buckets.pb.PushPathRequest.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.PushPathRequest.prototype.hasChunk = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */


proto.api.buckets.pb.PushPathResponse.oneofGroups_ = [[1, 2]];
/**
 * @enum {number}
 */

proto.api.buckets.pb.PushPathResponse.PayloadCase = {
  PAYLOAD_NOT_SET: 0,
  EVENT: 1,
  ERROR: 2
};
/**
 * @return {proto.api.buckets.pb.PushPathResponse.PayloadCase}
 */

proto.api.buckets.pb.PushPathResponse.prototype.getPayloadCase = function () {
  return (
    /** @type {proto.api.buckets.pb.PushPathResponse.PayloadCase} */
    jspb.Message.computeOneofCase(this, proto.api.buckets.pb.PushPathResponse.oneofGroups_[0])
  );
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PushPathResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PushPathResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PushPathResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PushPathResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      event: (f = msg.getEvent()) && proto.api.buckets.pb.PushPathResponse.Event.toObject(includeInstance, f),
      error: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PushPathResponse}
 */


proto.api.buckets.pb.PushPathResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PushPathResponse();
  return proto.api.buckets.pb.PushPathResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PushPathResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PushPathResponse}
 */


proto.api.buckets.pb.PushPathResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.buckets.pb.PushPathResponse.Event();
        reader.readMessage(value, proto.api.buckets.pb.PushPathResponse.Event.deserializeBinaryFromReader);
        msg.setEvent(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setError(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PushPathResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PushPathResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PushPathResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PushPathResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getEvent();

  if (f != null) {
    writer.writeMessage(1, f, proto.api.buckets.pb.PushPathResponse.Event.serializeBinaryToWriter);
  }

  f =
  /** @type {string} */
  jspb.Message.getField(message, 2);

  if (f != null) {
    writer.writeString(2, f);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PushPathResponse.Event.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PushPathResponse.Event.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PushPathResponse.Event} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PushPathResponse.Event.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      name: jspb.Message.getFieldWithDefault(msg, 1, ""),
      path: jspb.Message.getFieldWithDefault(msg, 2, ""),
      bytes: jspb.Message.getFieldWithDefault(msg, 3, 0),
      size: jspb.Message.getFieldWithDefault(msg, 4, ""),
      root: (f = msg.getRoot()) && proto.api.buckets.pb.Root.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PushPathResponse.Event}
 */


proto.api.buckets.pb.PushPathResponse.Event.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PushPathResponse.Event();
  return proto.api.buckets.pb.PushPathResponse.Event.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PushPathResponse.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PushPathResponse.Event}
 */


proto.api.buckets.pb.PushPathResponse.Event.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setBytes(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSize(value);
        break;

      case 5:
        var value = new proto.api.buckets.pb.Root();
        reader.readMessage(value, proto.api.buckets.pb.Root.deserializeBinaryFromReader);
        msg.setRoot(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PushPathResponse.Event.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PushPathResponse.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PushPathResponse.Event.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getBytes();

  if (f !== 0) {
    writer.writeInt64(3, f);
  }

  f = message.getSize();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getRoot();

  if (f != null) {
    writer.writeMessage(5, f, proto.api.buckets.pb.Root.serializeBinaryToWriter);
  }
};
/**
 * optional string name = 1;
 * @return {string}
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PushPathResponse.Event} returns this
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.setName = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PushPathResponse.Event} returns this
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 bytes = 3;
 * @return {number}
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.getBytes = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.PushPathResponse.Event} returns this
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.setBytes = function (value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string size = 4;
 * @return {string}
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.getSize = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PushPathResponse.Event} returns this
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.setSize = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional Root root = 5;
 * @return {?proto.api.buckets.pb.Root}
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.getRoot = function () {
  return (
    /** @type{?proto.api.buckets.pb.Root} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.Root, 5)
  );
};
/**
 * @param {?proto.api.buckets.pb.Root|undefined} value
 * @return {!proto.api.buckets.pb.PushPathResponse.Event} returns this
*/


proto.api.buckets.pb.PushPathResponse.Event.prototype.setRoot = function (value) {
  return jspb.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.PushPathResponse.Event} returns this
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.clearRoot = function () {
  return this.setRoot(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.PushPathResponse.Event.prototype.hasRoot = function () {
  return jspb.Message.getField(this, 5) != null;
};
/**
 * optional Event event = 1;
 * @return {?proto.api.buckets.pb.PushPathResponse.Event}
 */


proto.api.buckets.pb.PushPathResponse.prototype.getEvent = function () {
  return (
    /** @type{?proto.api.buckets.pb.PushPathResponse.Event} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.PushPathResponse.Event, 1)
  );
};
/**
 * @param {?proto.api.buckets.pb.PushPathResponse.Event|undefined} value
 * @return {!proto.api.buckets.pb.PushPathResponse} returns this
*/


proto.api.buckets.pb.PushPathResponse.prototype.setEvent = function (value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.api.buckets.pb.PushPathResponse.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.PushPathResponse} returns this
 */


proto.api.buckets.pb.PushPathResponse.prototype.clearEvent = function () {
  return this.setEvent(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.PushPathResponse.prototype.hasEvent = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional string error = 2;
 * @return {string}
 */


proto.api.buckets.pb.PushPathResponse.prototype.getError = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PushPathResponse} returns this
 */


proto.api.buckets.pb.PushPathResponse.prototype.setError = function (value) {
  return jspb.Message.setOneofField(this, 2, proto.api.buckets.pb.PushPathResponse.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.api.buckets.pb.PushPathResponse} returns this
 */


proto.api.buckets.pb.PushPathResponse.prototype.clearError = function () {
  return jspb.Message.setOneofField(this, 2, proto.api.buckets.pb.PushPathResponse.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.PushPathResponse.prototype.hasError = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PullPathRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PullPathRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PullPathRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PullPathRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      path: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PullPathRequest}
 */


proto.api.buckets.pb.PullPathRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PullPathRequest();
  return proto.api.buckets.pb.PullPathRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PullPathRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PullPathRequest}
 */


proto.api.buckets.pb.PullPathRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PullPathRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PullPathRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PullPathRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PullPathRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.PullPathRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PullPathRequest} returns this
 */


proto.api.buckets.pb.PullPathRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */


proto.api.buckets.pb.PullPathRequest.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PullPathRequest} returns this
 */


proto.api.buckets.pb.PullPathRequest.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PullPathResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PullPathResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PullPathResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PullPathResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      chunk: msg.getChunk_asB64()
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PullPathResponse}
 */


proto.api.buckets.pb.PullPathResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PullPathResponse();
  return proto.api.buckets.pb.PullPathResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PullPathResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PullPathResponse}
 */


proto.api.buckets.pb.PullPathResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setChunk(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PullPathResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PullPathResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PullPathResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PullPathResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getChunk_asU8();

  if (f.length > 0) {
    writer.writeBytes(1, f);
  }
};
/**
 * optional bytes chunk = 1;
 * @return {!(string|Uint8Array)}
 */


proto.api.buckets.pb.PullPathResponse.prototype.getChunk = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * optional bytes chunk = 1;
 * This is a type-conversion wrapper around `getChunk()`
 * @return {string}
 */


proto.api.buckets.pb.PullPathResponse.prototype.getChunk_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getChunk())
  );
};
/**
 * optional bytes chunk = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChunk()`
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PullPathResponse.prototype.getChunk_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getChunk())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.buckets.pb.PullPathResponse} returns this
 */


proto.api.buckets.pb.PullPathResponse.prototype.setChunk = function (value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PullIpfsPathRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PullIpfsPathRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PullIpfsPathRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PullIpfsPathRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      path: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PullIpfsPathRequest}
 */


proto.api.buckets.pb.PullIpfsPathRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PullIpfsPathRequest();
  return proto.api.buckets.pb.PullIpfsPathRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PullIpfsPathRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PullIpfsPathRequest}
 */


proto.api.buckets.pb.PullIpfsPathRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PullIpfsPathRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PullIpfsPathRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PullIpfsPathRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PullIpfsPathRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string path = 1;
 * @return {string}
 */


proto.api.buckets.pb.PullIpfsPathRequest.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PullIpfsPathRequest} returns this
 */


proto.api.buckets.pb.PullIpfsPathRequest.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PullIpfsPathResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PullIpfsPathResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PullIpfsPathResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PullIpfsPathResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      chunk: msg.getChunk_asB64()
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PullIpfsPathResponse}
 */


proto.api.buckets.pb.PullIpfsPathResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PullIpfsPathResponse();
  return proto.api.buckets.pb.PullIpfsPathResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PullIpfsPathResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PullIpfsPathResponse}
 */


proto.api.buckets.pb.PullIpfsPathResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setChunk(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PullIpfsPathResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PullIpfsPathResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PullIpfsPathResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PullIpfsPathResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getChunk_asU8();

  if (f.length > 0) {
    writer.writeBytes(1, f);
  }
};
/**
 * optional bytes chunk = 1;
 * @return {!(string|Uint8Array)}
 */


proto.api.buckets.pb.PullIpfsPathResponse.prototype.getChunk = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * optional bytes chunk = 1;
 * This is a type-conversion wrapper around `getChunk()`
 * @return {string}
 */


proto.api.buckets.pb.PullIpfsPathResponse.prototype.getChunk_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getChunk())
  );
};
/**
 * optional bytes chunk = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChunk()`
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PullIpfsPathResponse.prototype.getChunk_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getChunk())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.buckets.pb.PullIpfsPathResponse} returns this
 */


proto.api.buckets.pb.PullIpfsPathResponse.prototype.setChunk = function (value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.SetPathRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.SetPathRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.SetPathRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.SetPathRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      path: jspb.Message.getFieldWithDefault(msg, 2, ""),
      cid: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.SetPathRequest}
 */


proto.api.buckets.pb.SetPathRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.SetPathRequest();
  return proto.api.buckets.pb.SetPathRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.SetPathRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.SetPathRequest}
 */


proto.api.buckets.pb.SetPathRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCid(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.SetPathRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.SetPathRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.SetPathRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.SetPathRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCid();

  if (f.length > 0) {
    writer.writeString(3, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.SetPathRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.SetPathRequest} returns this
 */


proto.api.buckets.pb.SetPathRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */


proto.api.buckets.pb.SetPathRequest.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.SetPathRequest} returns this
 */


proto.api.buckets.pb.SetPathRequest.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string cid = 3;
 * @return {string}
 */


proto.api.buckets.pb.SetPathRequest.prototype.getCid = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.SetPathRequest} returns this
 */


proto.api.buckets.pb.SetPathRequest.prototype.setCid = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.SetPathResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.SetPathResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.SetPathResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.SetPathResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.SetPathResponse}
 */


proto.api.buckets.pb.SetPathResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.SetPathResponse();
  return proto.api.buckets.pb.SetPathResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.SetPathResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.SetPathResponse}
 */


proto.api.buckets.pb.SetPathResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.SetPathResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.SetPathResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.SetPathResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.SetPathResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.RemoveRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.RemoveRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.RemoveRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.RemoveRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.RemoveRequest}
 */


proto.api.buckets.pb.RemoveRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.RemoveRequest();
  return proto.api.buckets.pb.RemoveRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.RemoveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.RemoveRequest}
 */


proto.api.buckets.pb.RemoveRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.RemoveRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.RemoveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.RemoveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.RemoveRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.RemoveRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.RemoveRequest} returns this
 */


proto.api.buckets.pb.RemoveRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.RemoveResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.RemoveResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.RemoveResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.RemoveResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.RemoveResponse}
 */


proto.api.buckets.pb.RemoveResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.RemoveResponse();
  return proto.api.buckets.pb.RemoveResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.RemoveResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.RemoveResponse}
 */


proto.api.buckets.pb.RemoveResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.RemoveResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.RemoveResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.RemoveResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.RemoveResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.RemovePathRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.RemovePathRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.RemovePathRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.RemovePathRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      path: jspb.Message.getFieldWithDefault(msg, 2, ""),
      root: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.RemovePathRequest}
 */


proto.api.buckets.pb.RemovePathRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.RemovePathRequest();
  return proto.api.buckets.pb.RemovePathRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.RemovePathRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.RemovePathRequest}
 */


proto.api.buckets.pb.RemovePathRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setRoot(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.RemovePathRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.RemovePathRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.RemovePathRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.RemovePathRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getRoot();

  if (f.length > 0) {
    writer.writeString(3, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.RemovePathRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.RemovePathRequest} returns this
 */


proto.api.buckets.pb.RemovePathRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */


proto.api.buckets.pb.RemovePathRequest.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.RemovePathRequest} returns this
 */


proto.api.buckets.pb.RemovePathRequest.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string root = 3;
 * @return {string}
 */


proto.api.buckets.pb.RemovePathRequest.prototype.getRoot = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.RemovePathRequest} returns this
 */


proto.api.buckets.pb.RemovePathRequest.prototype.setRoot = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.RemovePathResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.RemovePathResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.RemovePathResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.RemovePathResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      root: (f = msg.getRoot()) && proto.api.buckets.pb.Root.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.RemovePathResponse}
 */


proto.api.buckets.pb.RemovePathResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.RemovePathResponse();
  return proto.api.buckets.pb.RemovePathResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.RemovePathResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.RemovePathResponse}
 */


proto.api.buckets.pb.RemovePathResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.buckets.pb.Root();
        reader.readMessage(value, proto.api.buckets.pb.Root.deserializeBinaryFromReader);
        msg.setRoot(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.RemovePathResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.RemovePathResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.RemovePathResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.RemovePathResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getRoot();

  if (f != null) {
    writer.writeMessage(1, f, proto.api.buckets.pb.Root.serializeBinaryToWriter);
  }
};
/**
 * optional Root root = 1;
 * @return {?proto.api.buckets.pb.Root}
 */


proto.api.buckets.pb.RemovePathResponse.prototype.getRoot = function () {
  return (
    /** @type{?proto.api.buckets.pb.Root} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.Root, 1)
  );
};
/**
 * @param {?proto.api.buckets.pb.Root|undefined} value
 * @return {!proto.api.buckets.pb.RemovePathResponse} returns this
*/


proto.api.buckets.pb.RemovePathResponse.prototype.setRoot = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.RemovePathResponse} returns this
 */


proto.api.buckets.pb.RemovePathResponse.prototype.clearRoot = function () {
  return this.setRoot(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.RemovePathResponse.prototype.hasRoot = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PushPathAccessRolesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PushPathAccessRolesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PushPathAccessRolesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PushPathAccessRolesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      path: jspb.Message.getFieldWithDefault(msg, 2, ""),
      rolesMap: (f = msg.getRolesMap()) ? f.toObject(includeInstance, undefined) : []
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PushPathAccessRolesRequest}
 */


proto.api.buckets.pb.PushPathAccessRolesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PushPathAccessRolesRequest();
  return proto.api.buckets.pb.PushPathAccessRolesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PushPathAccessRolesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PushPathAccessRolesRequest}
 */


proto.api.buckets.pb.PushPathAccessRolesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      case 3:
        var value = msg.getRolesMap();
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readEnum, null, "", 0);
        });
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PushPathAccessRolesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PushPathAccessRolesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PushPathAccessRolesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PushPathAccessRolesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getRolesMap(true);

  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeEnum);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.PushPathAccessRolesRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PushPathAccessRolesRequest} returns this
 */


proto.api.buckets.pb.PushPathAccessRolesRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */


proto.api.buckets.pb.PushPathAccessRolesRequest.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PushPathAccessRolesRequest} returns this
 */


proto.api.buckets.pb.PushPathAccessRolesRequest.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * map<string, PathAccessRole> roles = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.api.buckets.pb.PathAccessRole>}
 */


proto.api.buckets.pb.PushPathAccessRolesRequest.prototype.getRolesMap = function (opt_noLazyCreate) {
  return (
    /** @type {!jspb.Map<string,!proto.api.buckets.pb.PathAccessRole>} */
    jspb.Message.getMapField(this, 3, opt_noLazyCreate, null)
  );
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.api.buckets.pb.PushPathAccessRolesRequest} returns this
 */


proto.api.buckets.pb.PushPathAccessRolesRequest.prototype.clearRolesMap = function () {
  this.getRolesMap().clear();
  return this;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PushPathAccessRolesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PushPathAccessRolesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PushPathAccessRolesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PushPathAccessRolesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PushPathAccessRolesResponse}
 */


proto.api.buckets.pb.PushPathAccessRolesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PushPathAccessRolesResponse();
  return proto.api.buckets.pb.PushPathAccessRolesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PushPathAccessRolesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PushPathAccessRolesResponse}
 */


proto.api.buckets.pb.PushPathAccessRolesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PushPathAccessRolesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PushPathAccessRolesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PushPathAccessRolesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PushPathAccessRolesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PullPathAccessRolesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PullPathAccessRolesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PullPathAccessRolesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PullPathAccessRolesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      path: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PullPathAccessRolesRequest}
 */


proto.api.buckets.pb.PullPathAccessRolesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PullPathAccessRolesRequest();
  return proto.api.buckets.pb.PullPathAccessRolesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PullPathAccessRolesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PullPathAccessRolesRequest}
 */


proto.api.buckets.pb.PullPathAccessRolesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPath(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PullPathAccessRolesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PullPathAccessRolesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PullPathAccessRolesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PullPathAccessRolesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPath();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.PullPathAccessRolesRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PullPathAccessRolesRequest} returns this
 */


proto.api.buckets.pb.PullPathAccessRolesRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */


proto.api.buckets.pb.PullPathAccessRolesRequest.prototype.getPath = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.PullPathAccessRolesRequest} returns this
 */


proto.api.buckets.pb.PullPathAccessRolesRequest.prototype.setPath = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.PullPathAccessRolesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.PullPathAccessRolesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.PullPathAccessRolesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.PullPathAccessRolesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      rolesMap: (f = msg.getRolesMap()) ? f.toObject(includeInstance, undefined) : []
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.PullPathAccessRolesResponse}
 */


proto.api.buckets.pb.PullPathAccessRolesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.PullPathAccessRolesResponse();
  return proto.api.buckets.pb.PullPathAccessRolesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.PullPathAccessRolesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.PullPathAccessRolesResponse}
 */


proto.api.buckets.pb.PullPathAccessRolesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = msg.getRolesMap();
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readEnum, null, "", 0);
        });
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.PullPathAccessRolesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.PullPathAccessRolesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.PullPathAccessRolesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.PullPathAccessRolesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getRolesMap(true);

  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeEnum);
  }
};
/**
 * map<string, PathAccessRole> roles = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.api.buckets.pb.PathAccessRole>}
 */


proto.api.buckets.pb.PullPathAccessRolesResponse.prototype.getRolesMap = function (opt_noLazyCreate) {
  return (
    /** @type {!jspb.Map<string,!proto.api.buckets.pb.PathAccessRole>} */
    jspb.Message.getMapField(this, 1, opt_noLazyCreate, null)
  );
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.api.buckets.pb.PullPathAccessRolesResponse} returns this
 */


proto.api.buckets.pb.PullPathAccessRolesResponse.prototype.clearRolesMap = function () {
  this.getRolesMap().clear();
  return this;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.api.buckets.pb.ArchiveConfig.repeatedFields_ = [3, 4, 5];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveConfig.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveConfig.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveConfig} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveConfig.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      repFactor: jspb.Message.getFieldWithDefault(msg, 1, 0),
      dealMinDuration: jspb.Message.getFieldWithDefault(msg, 2, 0),
      excludedMinersList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
      trustedMinersList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
      countryCodesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
      renew: (f = msg.getRenew()) && proto.api.buckets.pb.ArchiveRenew.toObject(includeInstance, f),
      addr: jspb.Message.getFieldWithDefault(msg, 7, ""),
      maxPrice: jspb.Message.getFieldWithDefault(msg, 8, 0),
      fastRetrieval: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
      dealStartOffset: jspb.Message.getFieldWithDefault(msg, 10, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveConfig}
 */


proto.api.buckets.pb.ArchiveConfig.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveConfig();
  return proto.api.buckets.pb.ArchiveConfig.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveConfig}
 */


proto.api.buckets.pb.ArchiveConfig.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setRepFactor(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setDealMinDuration(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addExcludedMiners(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addTrustedMiners(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addCountryCodes(value);
        break;

      case 6:
        var value = new proto.api.buckets.pb.ArchiveRenew();
        reader.readMessage(value, proto.api.buckets.pb.ArchiveRenew.deserializeBinaryFromReader);
        msg.setRenew(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAddr(value);
        break;

      case 8:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setMaxPrice(value);
        break;

      case 9:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setFastRetrieval(value);
        break;

      case 10:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setDealStartOffset(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveConfig.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getRepFactor();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getDealMinDuration();

  if (f !== 0) {
    writer.writeInt64(2, f);
  }

  f = message.getExcludedMinersList();

  if (f.length > 0) {
    writer.writeRepeatedString(3, f);
  }

  f = message.getTrustedMinersList();

  if (f.length > 0) {
    writer.writeRepeatedString(4, f);
  }

  f = message.getCountryCodesList();

  if (f.length > 0) {
    writer.writeRepeatedString(5, f);
  }

  f = message.getRenew();

  if (f != null) {
    writer.writeMessage(6, f, proto.api.buckets.pb.ArchiveRenew.serializeBinaryToWriter);
  }

  f = message.getAddr();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getMaxPrice();

  if (f !== 0) {
    writer.writeUint64(8, f);
  }

  f = message.getFastRetrieval();

  if (f) {
    writer.writeBool(9, f);
  }

  f = message.getDealStartOffset();

  if (f !== 0) {
    writer.writeInt64(10, f);
  }
};
/**
 * optional int32 rep_factor = 1;
 * @return {number}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.getRepFactor = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.setRepFactor = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int64 deal_min_duration = 2;
 * @return {number}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.getDealMinDuration = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.setDealMinDuration = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * repeated string excluded_miners = 3;
 * @return {!Array<string>}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.getExcludedMinersList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 3)
  );
};
/**
 * @param {!Array<string>} value
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.setExcludedMinersList = function (value) {
  return jspb.Message.setField(this, 3, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.addExcludedMiners = function (value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.clearExcludedMinersList = function () {
  return this.setExcludedMinersList([]);
};
/**
 * repeated string trusted_miners = 4;
 * @return {!Array<string>}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.getTrustedMinersList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 4)
  );
};
/**
 * @param {!Array<string>} value
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.setTrustedMinersList = function (value) {
  return jspb.Message.setField(this, 4, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.addTrustedMiners = function (value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.clearTrustedMinersList = function () {
  return this.setTrustedMinersList([]);
};
/**
 * repeated string country_codes = 5;
 * @return {!Array<string>}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.getCountryCodesList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 5)
  );
};
/**
 * @param {!Array<string>} value
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.setCountryCodesList = function (value) {
  return jspb.Message.setField(this, 5, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.addCountryCodes = function (value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.clearCountryCodesList = function () {
  return this.setCountryCodesList([]);
};
/**
 * optional ArchiveRenew renew = 6;
 * @return {?proto.api.buckets.pb.ArchiveRenew}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.getRenew = function () {
  return (
    /** @type{?proto.api.buckets.pb.ArchiveRenew} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.ArchiveRenew, 6)
  );
};
/**
 * @param {?proto.api.buckets.pb.ArchiveRenew|undefined} value
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
*/


proto.api.buckets.pb.ArchiveConfig.prototype.setRenew = function (value) {
  return jspb.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.clearRenew = function () {
  return this.setRenew(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.hasRenew = function () {
  return jspb.Message.getField(this, 6) != null;
};
/**
 * optional string addr = 7;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.getAddr = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.setAddr = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional uint64 max_price = 8;
 * @return {number}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.getMaxPrice = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 8, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.setMaxPrice = function (value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional bool fast_retrieval = 9;
 * @return {boolean}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.getFastRetrieval = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 9, false)
  );
};
/**
 * @param {boolean} value
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.setFastRetrieval = function (value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};
/**
 * optional int64 deal_start_offset = 10;
 * @return {number}
 */


proto.api.buckets.pb.ArchiveConfig.prototype.getDealStartOffset = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.ArchiveConfig} returns this
 */


proto.api.buckets.pb.ArchiveConfig.prototype.setDealStartOffset = function (value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveRenew.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveRenew.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveRenew} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveRenew.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
      threshold: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveRenew}
 */


proto.api.buckets.pb.ArchiveRenew.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveRenew();
  return proto.api.buckets.pb.ArchiveRenew.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveRenew} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveRenew}
 */


proto.api.buckets.pb.ArchiveRenew.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setEnabled(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setThreshold(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveRenew.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveRenew.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveRenew} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveRenew.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getEnabled();

  if (f) {
    writer.writeBool(1, f);
  }

  f = message.getThreshold();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};
/**
 * optional bool enabled = 1;
 * @return {boolean}
 */


proto.api.buckets.pb.ArchiveRenew.prototype.getEnabled = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/**
 * @param {boolean} value
 * @return {!proto.api.buckets.pb.ArchiveRenew} returns this
 */


proto.api.buckets.pb.ArchiveRenew.prototype.setEnabled = function (value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional int32 threshold = 2;
 * @return {number}
 */


proto.api.buckets.pb.ArchiveRenew.prototype.getThreshold = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.buckets.pb.ArchiveRenew} returns this
 */


proto.api.buckets.pb.ArchiveRenew.prototype.setThreshold = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.DefaultArchiveConfigRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.DefaultArchiveConfigRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.DefaultArchiveConfigRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.DefaultArchiveConfigRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.DefaultArchiveConfigRequest}
 */


proto.api.buckets.pb.DefaultArchiveConfigRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.DefaultArchiveConfigRequest();
  return proto.api.buckets.pb.DefaultArchiveConfigRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.DefaultArchiveConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.DefaultArchiveConfigRequest}
 */


proto.api.buckets.pb.DefaultArchiveConfigRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.DefaultArchiveConfigRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.DefaultArchiveConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.DefaultArchiveConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.DefaultArchiveConfigRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.DefaultArchiveConfigRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.DefaultArchiveConfigRequest} returns this
 */


proto.api.buckets.pb.DefaultArchiveConfigRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.DefaultArchiveConfigResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.DefaultArchiveConfigResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.DefaultArchiveConfigResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.DefaultArchiveConfigResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      archiveConfig: (f = msg.getArchiveConfig()) && proto.api.buckets.pb.ArchiveConfig.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.DefaultArchiveConfigResponse}
 */


proto.api.buckets.pb.DefaultArchiveConfigResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.DefaultArchiveConfigResponse();
  return proto.api.buckets.pb.DefaultArchiveConfigResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.DefaultArchiveConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.DefaultArchiveConfigResponse}
 */


proto.api.buckets.pb.DefaultArchiveConfigResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.buckets.pb.ArchiveConfig();
        reader.readMessage(value, proto.api.buckets.pb.ArchiveConfig.deserializeBinaryFromReader);
        msg.setArchiveConfig(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.DefaultArchiveConfigResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.DefaultArchiveConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.DefaultArchiveConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.DefaultArchiveConfigResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getArchiveConfig();

  if (f != null) {
    writer.writeMessage(1, f, proto.api.buckets.pb.ArchiveConfig.serializeBinaryToWriter);
  }
};
/**
 * optional ArchiveConfig archive_config = 1;
 * @return {?proto.api.buckets.pb.ArchiveConfig}
 */


proto.api.buckets.pb.DefaultArchiveConfigResponse.prototype.getArchiveConfig = function () {
  return (
    /** @type{?proto.api.buckets.pb.ArchiveConfig} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.ArchiveConfig, 1)
  );
};
/**
 * @param {?proto.api.buckets.pb.ArchiveConfig|undefined} value
 * @return {!proto.api.buckets.pb.DefaultArchiveConfigResponse} returns this
*/


proto.api.buckets.pb.DefaultArchiveConfigResponse.prototype.setArchiveConfig = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.DefaultArchiveConfigResponse} returns this
 */


proto.api.buckets.pb.DefaultArchiveConfigResponse.prototype.clearArchiveConfig = function () {
  return this.setArchiveConfig(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.DefaultArchiveConfigResponse.prototype.hasArchiveConfig = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.SetDefaultArchiveConfigRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.SetDefaultArchiveConfigRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.SetDefaultArchiveConfigRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.SetDefaultArchiveConfigRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      archiveConfig: (f = msg.getArchiveConfig()) && proto.api.buckets.pb.ArchiveConfig.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.SetDefaultArchiveConfigRequest}
 */


proto.api.buckets.pb.SetDefaultArchiveConfigRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.SetDefaultArchiveConfigRequest();
  return proto.api.buckets.pb.SetDefaultArchiveConfigRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.SetDefaultArchiveConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.SetDefaultArchiveConfigRequest}
 */


proto.api.buckets.pb.SetDefaultArchiveConfigRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value = new proto.api.buckets.pb.ArchiveConfig();
        reader.readMessage(value, proto.api.buckets.pb.ArchiveConfig.deserializeBinaryFromReader);
        msg.setArchiveConfig(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.SetDefaultArchiveConfigRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.SetDefaultArchiveConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.SetDefaultArchiveConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.SetDefaultArchiveConfigRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getArchiveConfig();

  if (f != null) {
    writer.writeMessage(2, f, proto.api.buckets.pb.ArchiveConfig.serializeBinaryToWriter);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.SetDefaultArchiveConfigRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.SetDefaultArchiveConfigRequest} returns this
 */


proto.api.buckets.pb.SetDefaultArchiveConfigRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional ArchiveConfig archive_config = 2;
 * @return {?proto.api.buckets.pb.ArchiveConfig}
 */


proto.api.buckets.pb.SetDefaultArchiveConfigRequest.prototype.getArchiveConfig = function () {
  return (
    /** @type{?proto.api.buckets.pb.ArchiveConfig} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.ArchiveConfig, 2)
  );
};
/**
 * @param {?proto.api.buckets.pb.ArchiveConfig|undefined} value
 * @return {!proto.api.buckets.pb.SetDefaultArchiveConfigRequest} returns this
*/


proto.api.buckets.pb.SetDefaultArchiveConfigRequest.prototype.setArchiveConfig = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.SetDefaultArchiveConfigRequest} returns this
 */


proto.api.buckets.pb.SetDefaultArchiveConfigRequest.prototype.clearArchiveConfig = function () {
  return this.setArchiveConfig(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.SetDefaultArchiveConfigRequest.prototype.hasArchiveConfig = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.SetDefaultArchiveConfigResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.SetDefaultArchiveConfigResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.SetDefaultArchiveConfigResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.SetDefaultArchiveConfigResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.SetDefaultArchiveConfigResponse}
 */


proto.api.buckets.pb.SetDefaultArchiveConfigResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.SetDefaultArchiveConfigResponse();
  return proto.api.buckets.pb.SetDefaultArchiveConfigResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.SetDefaultArchiveConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.SetDefaultArchiveConfigResponse}
 */


proto.api.buckets.pb.SetDefaultArchiveConfigResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.SetDefaultArchiveConfigResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.SetDefaultArchiveConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.SetDefaultArchiveConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.SetDefaultArchiveConfigResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      archiveConfig: (f = msg.getArchiveConfig()) && proto.api.buckets.pb.ArchiveConfig.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveRequest}
 */


proto.api.buckets.pb.ArchiveRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveRequest();
  return proto.api.buckets.pb.ArchiveRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveRequest}
 */


proto.api.buckets.pb.ArchiveRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value = new proto.api.buckets.pb.ArchiveConfig();
        reader.readMessage(value, proto.api.buckets.pb.ArchiveConfig.deserializeBinaryFromReader);
        msg.setArchiveConfig(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getArchiveConfig();

  if (f != null) {
    writer.writeMessage(2, f, proto.api.buckets.pb.ArchiveConfig.serializeBinaryToWriter);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveRequest} returns this
 */


proto.api.buckets.pb.ArchiveRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional ArchiveConfig archive_config = 2;
 * @return {?proto.api.buckets.pb.ArchiveConfig}
 */


proto.api.buckets.pb.ArchiveRequest.prototype.getArchiveConfig = function () {
  return (
    /** @type{?proto.api.buckets.pb.ArchiveConfig} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.ArchiveConfig, 2)
  );
};
/**
 * @param {?proto.api.buckets.pb.ArchiveConfig|undefined} value
 * @return {!proto.api.buckets.pb.ArchiveRequest} returns this
*/


proto.api.buckets.pb.ArchiveRequest.prototype.setArchiveConfig = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.ArchiveRequest} returns this
 */


proto.api.buckets.pb.ArchiveRequest.prototype.clearArchiveConfig = function () {
  return this.setArchiveConfig(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.ArchiveRequest.prototype.hasArchiveConfig = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveResponse}
 */


proto.api.buckets.pb.ArchiveResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveResponse();
  return proto.api.buckets.pb.ArchiveResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveResponse}
 */


proto.api.buckets.pb.ArchiveResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveStatusRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveStatusRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveStatusRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveStatusRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveStatusRequest}
 */


proto.api.buckets.pb.ArchiveStatusRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveStatusRequest();
  return proto.api.buckets.pb.ArchiveStatusRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveStatusRequest}
 */


proto.api.buckets.pb.ArchiveStatusRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveStatusRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveStatusRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveStatusRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveStatusRequest} returns this
 */


proto.api.buckets.pb.ArchiveStatusRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveStatusResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveStatusResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveStatusResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveStatusResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      status: jspb.Message.getFieldWithDefault(msg, 2, 0),
      failedMsg: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveStatusResponse}
 */


proto.api.buckets.pb.ArchiveStatusResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveStatusResponse();
  return proto.api.buckets.pb.ArchiveStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveStatusResponse}
 */


proto.api.buckets.pb.ArchiveStatusResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value =
        /** @type {!proto.api.buckets.pb.ArchiveStatusResponse.Status} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setFailedMsg(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveStatusResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveStatusResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }

  f = message.getFailedMsg();

  if (f.length > 0) {
    writer.writeString(3, f);
  }
};
/**
 * @enum {number}
 */


proto.api.buckets.pb.ArchiveStatusResponse.Status = {
  STATUS_UNSPECIFIED: 0,
  STATUS_EXECUTING: 1,
  STATUS_FAILED: 2,
  STATUS_DONE: 3,
  STATUS_CANCELED: 4
};
/**
 * optional string key = 1;
 * @return {string}
 */

proto.api.buckets.pb.ArchiveStatusResponse.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveStatusResponse} returns this
 */


proto.api.buckets.pb.ArchiveStatusResponse.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Status status = 2;
 * @return {!proto.api.buckets.pb.ArchiveStatusResponse.Status}
 */


proto.api.buckets.pb.ArchiveStatusResponse.prototype.getStatus = function () {
  return (
    /** @type {!proto.api.buckets.pb.ArchiveStatusResponse.Status} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/**
 * @param {!proto.api.buckets.pb.ArchiveStatusResponse.Status} value
 * @return {!proto.api.buckets.pb.ArchiveStatusResponse} returns this
 */


proto.api.buckets.pb.ArchiveStatusResponse.prototype.setStatus = function (value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string failed_msg = 3;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveStatusResponse.prototype.getFailedMsg = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveStatusResponse} returns this
 */


proto.api.buckets.pb.ArchiveStatusResponse.prototype.setFailedMsg = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveInfoRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveInfoRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveInfoRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveInfoRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveInfoRequest}
 */


proto.api.buckets.pb.ArchiveInfoRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveInfoRequest();
  return proto.api.buckets.pb.ArchiveInfoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveInfoRequest}
 */


proto.api.buckets.pb.ArchiveInfoRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveInfoRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveInfoRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveInfoRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveInfoRequest} returns this
 */


proto.api.buckets.pb.ArchiveInfoRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveInfoResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveInfoResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveInfoResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveInfoResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, ""),
      archive: (f = msg.getArchive()) && proto.api.buckets.pb.ArchiveInfoResponse.Archive.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse}
 */


proto.api.buckets.pb.ArchiveInfoResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveInfoResponse();
  return proto.api.buckets.pb.ArchiveInfoResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse}
 */


proto.api.buckets.pb.ArchiveInfoResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      case 2:
        var value = new proto.api.buckets.pb.ArchiveInfoResponse.Archive();
        reader.readMessage(value, proto.api.buckets.pb.ArchiveInfoResponse.Archive.deserializeBinaryFromReader);
        msg.setArchive(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveInfoResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveInfoResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getArchive();

  if (f != null) {
    writer.writeMessage(2, f, proto.api.buckets.pb.ArchiveInfoResponse.Archive.serializeBinaryToWriter);
  }
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveInfoResponse.Archive.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveInfoResponse.Archive.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveInfoResponse.Archive} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveInfoResponse.Archive.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      cid: jspb.Message.getFieldWithDefault(msg, 1, ""),
      dealsList: jspb.Message.toObjectList(msg.getDealsList(), proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse.Archive}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveInfoResponse.Archive();
  return proto.api.buckets.pb.ArchiveInfoResponse.Archive.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveInfoResponse.Archive} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse.Archive}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCid(value);
        break;

      case 2:
        var value = new proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal();
        reader.readMessage(value, proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.deserializeBinaryFromReader);
        msg.addDeals(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveInfoResponse.Archive.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveInfoResponse.Archive} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCid();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getDealsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.serializeBinaryToWriter);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      proposalCid: jspb.Message.getFieldWithDefault(msg, 1, ""),
      miner: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal();
  return proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setProposalCid(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setMiner(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProposalCid();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getMiner();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string proposal_cid = 1;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.prototype.getProposalCid = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal} returns this
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.prototype.setProposalCid = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string miner = 2;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.prototype.getMiner = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal} returns this
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal.prototype.setMiner = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string cid = 1;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.prototype.getCid = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse.Archive} returns this
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.prototype.setCid = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated Deal deals = 2;
 * @return {!Array<!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal>}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.prototype.getDealsList = function () {
  return (
    /** @type{!Array<!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal>} */
    jspb.Message.getRepeatedWrapperField(this, proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal, 2)
  );
};
/**
 * @param {!Array<!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal>} value
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse.Archive} returns this
*/


proto.api.buckets.pb.ArchiveInfoResponse.Archive.prototype.setDealsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal=} opt_value
 * @param {number=} opt_index
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal}
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.prototype.addDeals = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.api.buckets.pb.ArchiveInfoResponse.Archive.Deal, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse.Archive} returns this
 */


proto.api.buckets.pb.ArchiveInfoResponse.Archive.prototype.clearDealsList = function () {
  return this.setDealsList([]);
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveInfoResponse.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse} returns this
 */


proto.api.buckets.pb.ArchiveInfoResponse.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Archive archive = 2;
 * @return {?proto.api.buckets.pb.ArchiveInfoResponse.Archive}
 */


proto.api.buckets.pb.ArchiveInfoResponse.prototype.getArchive = function () {
  return (
    /** @type{?proto.api.buckets.pb.ArchiveInfoResponse.Archive} */
    jspb.Message.getWrapperField(this, proto.api.buckets.pb.ArchiveInfoResponse.Archive, 2)
  );
};
/**
 * @param {?proto.api.buckets.pb.ArchiveInfoResponse.Archive|undefined} value
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse} returns this
*/


proto.api.buckets.pb.ArchiveInfoResponse.prototype.setArchive = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.api.buckets.pb.ArchiveInfoResponse} returns this
 */


proto.api.buckets.pb.ArchiveInfoResponse.prototype.clearArchive = function () {
  return this.setArchive(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.api.buckets.pb.ArchiveInfoResponse.prototype.hasArchive = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveWatchRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveWatchRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveWatchRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveWatchRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      key: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveWatchRequest}
 */


proto.api.buckets.pb.ArchiveWatchRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveWatchRequest();
  return proto.api.buckets.pb.ArchiveWatchRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveWatchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveWatchRequest}
 */


proto.api.buckets.pb.ArchiveWatchRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setKey(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveWatchRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveWatchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveWatchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveWatchRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKey();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string key = 1;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveWatchRequest.prototype.getKey = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveWatchRequest} returns this
 */


proto.api.buckets.pb.ArchiveWatchRequest.prototype.setKey = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.buckets.pb.ArchiveWatchResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.buckets.pb.ArchiveWatchResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.buckets.pb.ArchiveWatchResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.buckets.pb.ArchiveWatchResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      msg: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.buckets.pb.ArchiveWatchResponse}
 */


proto.api.buckets.pb.ArchiveWatchResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.buckets.pb.ArchiveWatchResponse();
  return proto.api.buckets.pb.ArchiveWatchResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.buckets.pb.ArchiveWatchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.buckets.pb.ArchiveWatchResponse}
 */


proto.api.buckets.pb.ArchiveWatchResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setMsg(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.buckets.pb.ArchiveWatchResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.buckets.pb.ArchiveWatchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.buckets.pb.ArchiveWatchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.buckets.pb.ArchiveWatchResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMsg();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string msg = 1;
 * @return {string}
 */


proto.api.buckets.pb.ArchiveWatchResponse.prototype.getMsg = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.buckets.pb.ArchiveWatchResponse} returns this
 */


proto.api.buckets.pb.ArchiveWatchResponse.prototype.setMsg = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * @enum {number}
 */


proto.api.buckets.pb.PathAccessRole = {
  PATH_ACCESS_ROLE_UNSPECIFIED: 0,
  PATH_ACCESS_ROLE_READER: 1,
  PATH_ACCESS_ROLE_WRITER: 2,
  PATH_ACCESS_ROLE_ADMIN: 3
};
goog.object.extend(exports, proto.api.buckets.pb);